import { ApplicationConfig, provideBrowserGlobalErrorListeners } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { routes } from './app.routes';
import { httpsEnforcerInterceptor } from './core/interceptors/https-enforcer.interceptor';
import { sanitizeRequestInterceptor } from './core/interceptors/sanitize-request.interceptor';
import { authExpiredInterceptor } from './core/interceptors/auth-expired.interceptor';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideCharts, withDefaultRegisterables } from 'ng2-charts';

export const appConfig: ApplicationConfig = {
  providers: [
    provideAnimations(),
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes),
    provideHttpClient(
      withInterceptors([
        httpsEnforcerInterceptor,
        sanitizeRequestInterceptor,
        authExpiredInterceptor,
      ]),
    ),
    provideCharts(withDefaultRegisterables()),
  ],
};
